module.exports = __webpack_public_path__ + "static/media/18ECA41.0caa0c68.jpg";